import a from"styled-components";import{theme as r}from"../../../../theme.js";const l=a.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  padding-bottom: env(safe-area-inset-bottom);
  padding-top: env(safe-area-inset-top);
  background-color: #33333399;
  overscroll-behavior: contain;
  width: ${({viewportSize:e})=>e.width}px;
  height: ${({viewportSize:e})=>e.height}px;
`,s=a.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${r.colors.shades[0]};
  border-radius: ${({fullScreen:e})=>e?0:r.radius*2}px;
  min-height: 300px;
  box-sizing: border-box;
  width: ${({fullScreen:e,autoWidth:o})=>e?"100%":o?"unset":"570px"};
  height: ${({fullScreen:e})=>e?"100%":"auto"};
  max-height: ${({fullScreen:e})=>e?"100vh":"90vh"};
  overflow: hidden;

  @media screen and (max-width: ${r.breakpoints.md}) {
    width: 100%;
    height: 100%;
    max-height: unset;
    border-radius: 0;
    min-height: unset;
  }
`,h=({footer:e,header:o,fullScreen:t,isMobile:n})=>{const d=n?"100%":t?"100vh":"90vh";let i=0;return e&&!n&&(i+=80),o&&(n?i+=56:i+=72),`calc(${d} - ${i}px)`},f=a.div`
  overflow-y: auto;
  min-height: 150px;
  max-height: ${({footer:e,header:o,fullScreen:t})=>h({footer:e,header:o,fullScreen:t,isMobile:!1})}; 
  box-sizing: border-box;
  @media screen and (max-width: ${r.breakpoints.md}) {
    max-height: unset;
    height: ${({footer:e,header:o,fullScreen:t})=>h({footer:e,header:o,fullScreen:t,isMobile:!0})};
    margin-top: ${({header:e})=>e?56:0}px;
  }
`;export{l as Container,s as Content,f as ModalContentContainer,h as getMaxHeight};
